import send from '../../../util/request';

//售卖品 查询
export function getProductList(data={}) {
  return send({
    url:'/ipp/quality/product/select',
    method:'POST',
    data
  });
};
//分类
export function getCategoryList(data={}) {
  return send({
    url:'/ipp/quality/product/categorys',
    method:'POST',
    data
  });
};



//抽检梯度----------------------------------------------
export function getQualityGradientSelect(data={}){
  return send({
    url:'/ipp/quality/gradient/select',
    method:'POST',
    data
  });
};
export function updateQualityGradientStatus(data={}){
  return send({
    url:'/ipp/quality/gradient/status',
    method:'POST',
    data
  });
};
export function saveQualityGradient(data={}){
  return send({
    url:'/ipp/quality/gradient/save',
    method:'POST',
    data
  });
};
export function getQualityGradientInfo(data={}){
  return send({
    url:'/ipp/quality/gradient/info',
    method:'POST',
    data
  });
};
//抽检梯度----------------------------------------------




//质检标准 ----------------------------------------------------
export function getQualityStandardSelect(data={}){
  return send({
    url:'/ipp/quality/standard/select',
    method:'POST',
    data
  });
};
export function saveQualityStandard(data={}){
  return send({
    url:'/ipp/quality/standard/save',
    method:'POST',
    data
  });
};
export function updateQualityStandardStatus(data={}){
  return send({
    url:'/ipp/quality/standard/status',
    method:'POST',
    data
  });
};
export function getQualityStandardInfo(data={}){
  return send({
    url:'/ipp/quality/standard/info',
    method:'POST',
    data
  });
};
//质检标准 ----------------------------------------------------



// 质检记录 -----------------------------------------------------
export function getQualityTask(data={}){
  return send({
    url:'/ipp/quality/task/select',
    method:'POST',
    data
  });
};
export function getQualityTaskInfo(data={}){
  return send({
    url:'/ipp/quality/task/info',
    method:'POST',
    data
  });
};


